import {ServerMethod} from './constant';

export let serverMixin = {
	data() {
		return {
			loading: false,
			emptyMessage: "",
		}
	},
	methods: {
		getAllFormData(data, lastAction) {
			let result = {},
				arProp = [
					{
						codeProp: this.result.PERSON_TYPE,
						name: 'PERSON_TYPE',
					},
					{
						codeProp: this.result.USER_PROFILES,
						name: 'PROFILE_ID',
					},
					{
						codeProp: this.result.PAY_SYSTEM,
						name: 'PAY_SYSTEM_ID',
					},
					{
						codeProp: this.result.DELIVERY,
						name: 'DELIVERY_ID',
					},
				],
				usedCustomLocationProperty = this.alternativeLocationProperty
					&& this.alternativeLocationProperty.VALUE
					&& this.alternativeLocationProperty.VALUE.length > 0 ? 1 : 0,
				locationPropId = this.locationProperty ? this.locationProperty.ID : 0
			;

			if (lastAction == ServerMethod.SAVE)
			{
				result = this.existingProp(arProp, true);

				result['ORDER_DESCRIPTION'] = this.comment.VALUE;

				result['location_type'] = 'code';

				if (!result.hasOwnProperty('profile_change')) {
					result['profile_change'] = 'N';
				}

				result['LOCATION_ALT_PROP_DISPLAY_MANUAL['+locationPropId+']'] = usedCustomLocationProperty;

				Object.assign({}, result, data);
			}
			else
			{
				result = this.existingProp(arProp);
				result[this.propCode('ORDER_DESCRIPTION')] = this.comment.VALUE;

				for (let key in data) {
					result[this.propCode(key)] = data[key];
				}

				result['order[location_type]'] = 'code';

				if (!result.hasOwnProperty('order[profile_change]')) {
					result['order[profile_change]'] = 'N';
				}

				result['order[LOCATION_ALT_PROP_DISPLAY_MANUAL['+locationPropId+']]'] = usedCustomLocationProperty;
			}

			return result;
		},
		propCode(code = '', orderProp = false, multipleKey) {
			if (code.toString().indexOf('.') > 0) {
				let arr = code.split('.'),
					result = "order";
				arr.forEach(function (element) {
					result += '[' + element + ']'
				});
				return result;
			}
			if (orderProp) {
				if (multipleKey) {
					return 'order[ORDER_PROP_' + code + '][' + multipleKey + ']'
				}
				return 'order[ORDER_PROP_' + code + ']'
			}
			return 'order[' + code + ']'
		},
		propCodeSend(code = '', multipleKey) {
			if (multipleKey) {
				return 'ORDER_PROP_' + code + '[' + multipleKey + ']'
			}
			return 'ORDER_PROP_' + code

		},
		existingProp(arProp, sendOrder) {
			let result = {};
			for (let prop of arProp) {
				let value = "";
				for (let key in prop.codeProp) {
					let id = prop.codeProp[key].hasOwnProperty('PROPERTY_ID') ? prop.codeProp[key].PROPERTY_ID : prop.codeProp[key].ID;
					if (prop.codeProp[key].CHECKED == "Y") {
						value = id;
						break;
					}
				}

				if (sendOrder) {
					result[prop.name] = value;
				} else {
					result[this.propCode(prop.name)] = value;
				}
			}

			for (let gIndex in this.propertyList) {
				let gProperty = this.propertyList[gIndex];
				for (let itemProperty of gProperty.items) {
					let propertyCode = sendOrder ? this.propCodeSend(itemProperty.ID) :  this.propCode(itemProperty.ID, sendOrder);
					result[propertyCode] = itemProperty.VALUE;
				}
			}
			return result;
		},
		ajaxRequestCoupon(action, arData)
		{
			let ajaxFormData = new FormData(),
				actionVariable = this.params.ACTION_VARIABLE
			;

			arData[actionVariable] = action;
			arData.IS_AUTHORIZED = (true === this.isAuthorized) ? 'Y' : 'N';
			arData.via_ajax = 'Y';
			arData.SITE_ID = this.siteId;
			arData.sessid = BX.bitrix_sessid();
			arData.signedParamsString = this.signedParamsString;
			arData['AGREEMENT'] = this.agreementChecked;
			arData['SUBSCRIPTION'] = this.subscriptionChecked;

			for (let key in arData)
			{
				ajaxFormData.set(key, arData[key]);
			}

			axios({
				method: 'POST',
				url: this.ajaxUrl,
				data: ajaxFormData,
			})
				.then((response) => {
					this.loading = false;

					// необходима для работы модулей доставок
					BX.onCustomEvent('onAjaxSuccess', [response.data]);
				})
				.catch((error) => {
					console.error(error);
					BX.onCustomEvent('onAjaxFailure', ['error', error]);
				});
		},
		async onAjaxRequest(params) {
			await this.ajaxRequest(
				(params && params.hasOwnProperty('action')) ? params.action : "",
				(params && params.hasOwnProperty('data')) ? params.data : "",
			);
		},
		async ajaxRequest(lastAction, arData)
		{
			if (this.loading)
				return;

			this.loading = true;
			lastAction = (lastAction && lastAction !== "") ? lastAction : ServerMethod.REFRESH;

			if (lastAction == ServerMethod.SAVE) {
				let isValid = await this.isValidate();
				if (!isValid) {

					if(!this.paymentSelected) {
						this.showErrorBlock(this.loc.SOA_ORDER_E_PAYMENT_SELECTED, () => {
							const element = document.getElementById('payment-systems-block');
							element.scrollIntoView({block: "center", inline: "center", behavior: "smooth"});
						});
					}
					else {
						this.showErrorBlock(this.loc.SOA_ORDER_E_ORDER_SAVE);
					}

					this.loading = false;

					return;
				}

				if(this.needPreOrderValidation)
				{
					this.showPreOrderValidation();
					this.loading = false;
					return;
				}

			}

			let ajaxFormData = new FormData(),
				actionVariable = this.params.ACTION_VARIABLE
			;

			let data = this.getAllFormData(arData, lastAction);
			if(
				lastAction == ServerMethod.ENTER_COUPON
				|| lastAction == ServerMethod.REMOVE_COUPON
			) {
				for (let code in arData) {
					data[code] = arData[code];
				}
			}

			data[actionVariable] = lastAction;
			data['order[' + actionVariable + ']'] = ServerMethod.SAVE;
			data['order[sessid]'] = BX.bitrix_sessid();

			data.IS_AUTHORIZED = (true === this.isAuthorized) ? 'Y' : 'N';
			data.via_ajax = 'Y';
			data.SITE_ID = this.siteId;
			data.sessid = BX.bitrix_sessid();
			data.signedParamsString = this.signedParamsString;
			data['AGREEMENT'] = this.agreementChecked;
			data['SUBSCRIPTION'] = this.subscriptionChecked;


			for (let key in data) {
				ajaxFormData.set(key, data[key]);
			}
			axios({
				method: 'POST',
				url: this.ajaxUrl,
				data: ajaxFormData,
				headers: {
					'X-Bitrix-Csrf-Token': BX.bitrix_sessid()
				}
			})
				.then((response) => {
					if (response.data.redirect && response.data.redirect.length)
						document.location.href = response.data.redirect;

					this.loading = false;

					if (!response.data.order || Array.isArray(response.data.order) && response.data.order.length === 0)
					{
						if(ServerMethod.ENTER_COUPON == lastAction) {
							this.addDangerCoupon(response.data);
						}
						else if(ServerMethod.REMOVE_COUPON == lastAction) {
							this.removeCoupon(response.data);
						}
						else {
							console.error(response.data);
							BX.onCustomEvent('onAjaxFailure', ['error', response.data]);
						}

						return;
					}
					else {
						if(ServerMethod.ENTER_COUPON == lastAction) {
							this.$gtag.event(this.metricGoal.ADD_PROMO_CODE);
							this.$metrika.reachGoal(this.metricGoal.ADD_PROMO_CODE);
							console.log('купон добавлен успешно!');
						}
					}

					if (!response.data.order.ERROR || response.data.order.ERROR.length == 0) {
						if (lastAction == ServerMethod.SAVE) {

							this.$gtag.event(this.metricGoal.SAVE_ORDER);
							this.$metrika.reachGoal(this.metricGoal.SAVE_ORDER);

							this.clearSavedUserData();
							this.clearSavedActiveStep();
							this.showSuccessBlock(response.data);
							return;
						}

						this.result = response.data.order;

						this.pickupDeliveryTime = this.result.IIKO_DELIVERY_TIME.PICKUP_TIME_VALUE
							? this.result.IIKO_DELIVERY_TIME.PICKUP_TIME_VALUE
							: false;

						this.__init();
						this.__initPreOrderData();
						//this.__initAdditionalProductData();
					}
					else {
						let emptyMessage = [];
						for (let blockCode in response.data.order.ERROR)
						{
							if("string" == typeof response.data.order.ERROR[blockCode])
							{
								emptyMessage.push(response.data.order.ERROR[blockCode]);
								continue;
							}

							for (let key in response.data.order.ERROR[blockCode])
							{
								emptyMessage.push(response.data.order.ERROR[blockCode][key]);
							}
						}

						if (response.data.order.IIKO_DELIVERY_TIME) {
							this.showWarningBlock(emptyMessage.join("<br/>"), this.loc.SOA_ORDER_MODAL_TIME_CHANGED_TITLE, () => {
								this.result.IIKO_DELIVERY_TIME = response.data.order.IIKO_DELIVERY_TIME;

								if (this.result.IIKO_DELIVERY_TIME.PICKUP_TIME_VALUE) {
									this.pickupDeliveryTime = this.result.IIKO_DELIVERY_TIME.PICKUP_TIME_VALUE;
									this.setDeliveryTimeWithChange(this.result.IIKO_DELIVERY_TIME.PICKUP_TIME_VALUE);
								}
							});
						} else {
							this.showErrorBlock(emptyMessage.join("<br/>"));
						}
					}

					// необходима для работы модулей доставок
					BX.onCustomEvent('onAjaxSuccess', [response.data]);
				})
				.catch((error) => {
					console.error(error);
					BX.onCustomEvent('onAjaxFailure', ['error', error]);
				});
		},
		showSuccessBlock(response)
		{

			setTimeout(() => {
				location.href = this.params.CURRENT_PAGE + '?ORDER_ID=' + response.order.ID;
			}, 200);

			return;

			if (this.$dialog) {

				this.$dialog
					.alert({
						title: this.loc.SOA_ORDER_SUC_TITLE,
						body: this.loc.SOA_ORDER_SUC,
						loader: true,
						pretitle: '<div class="m-auto h-28 mb-6">' + this.icons.success + '</div>'
					}, {
						html: true,
						okBtnClass: 'b-btnCheck',
						okText: this.loc.SOA_ORDER_SUC_GO_TO_PAYMENT
					})
					.then(() => {
						this.$gtag.event(this.metricGoal.PAY_ORDER);
						this.$metrika.reachGoal(this.metricGoal.PAY_ORDER);


					})
					.catch(() => {
						location.href = BX.message("SITE_DIR");
					})
				;
			} else if (alert(this.loc.SOA_ORDER_SUC_TITLE + " " + this.loc.SOA_ORDER_SUC)) {
				location.href = BX.message("SITE_DIR");
			}

		},
		showErrorBlock(message, callback = null)
		{
			if (this.$dialog) {

				this.$dialog
					.alert({
						title: this.loc.SOA_ORDER_ERROR_TITLE,
						body: message,
						loader: true,
						pretitle: '<div class="m-auto h-28 mb-6">' + this.icons.error + '</div>'
					}, {
						html: true,
						okBtnClass: 'b-btnCheck',
						okText: this.loc.SOA_ORDER_MODAL_PREORDER_BTN_CLOSE
					}).then(()=>{
						callback();
				});
				;
			} else if (alert(this.loc.SOA_ORDER_ERROR_TITLE + " " + message)) {

			}
		},
		showWarningBlock(message, title = "", callback = () => {})
		{
			if (this.$dialog) {
				this.$dialog
					.alert({
						title: title != "" ? title : this.loc.SOA_ORDER_WARNING_TITLE,
						body: message,
						loader: true,
						pretitle: ''
					}, {
						html: true,
						okBtnClass: 'b-btnCheck',
						okText: this.loc.SOA_ORDER_MODAL_BTN_NEXT_TITLE
					})
					.then(callback)
				;
			} else if (alert(this.loc.SOA_ORDER_WARNING_TITLE + " " + message)) {
				if (callback) {
					callback.apply();
				}
			}
		},
		addDangerCoupon(coupon) {
			this.result.COUPON_LIST.push({
				COUPON: coupon,
				CHECK_CODE_TEXT: [this.loc.SOA_SUM_COUPON_CHECK_NOT_FOUND],
				JS_STATUS: 'BAD'
			});
		},
		removeCoupon(coupon) {
			let index = this.result.COUPON_LIST.findIndex(x => x.COUPON === coupon);
			if (index != -1) {
				this.$delete(this.result.COUPON_LIST, index);
			}
		},
		async isValidate(component, isValid = true) {
			let val = null, self = this,
				ref = 'fields', refGroup = 'group';

			if (component) {
				self = component;
			}

			if (self.$refs.hasOwnProperty(ref)) {
				let isIterable = self.$refs[ref] != null && typeof self.$refs[ref][Symbol.iterator] === 'function';
				if (isIterable) {
					for (let field of self.$refs[ref]) {
						val = await field.checkValid();
						if (!val) {
							isValid = false;
						}
					}
				} else {
					isValid = await self.$refs[ref].checkValid();
				}
			} else if (self.$refs.hasOwnProperty(refGroup)) {
				let isIterable = self.$refs[refGroup] != null && typeof self.$refs[refGroup][Symbol.iterator] === 'function';
				if (isIterable) {
					for (let group of self.$refs[refGroup]) {
						val = await this.isValidate(group);
						if (!val) {
							isValid = false;
						}
					}
				} else {
					isValid = await this.isValidate(self.$refs[refGroup], isValid);
				}
			}
			return isValid;
		},
		__init() {

		}
	}
}

export default serverMixin;